import {Component, Prop} from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";

@Component({
    components: {
        Modal
    },
})
export default class WorkItemSelectModal extends ItemSelectModal {
    @Prop({default: () => "作業者"})
    itemKindName!: string

    @Prop({default: () => "/workers"})
    apiPath!: string;

    @Prop({default: () => true})
    multiple!: boolean

    @Prop({default: () => false})
    editable!: boolean
}
